const IN_POD_STATUSES = ['ACTIVE', 'TRIALING', 'PAST_DUE'];

export { IN_POD_STATUSES };
